import api from 'core/util/api';
import { action, observable, runInAction } from 'mobx';

/**
 * Map indicating the presence of device traps within the last two weeks, keyed by device ID which are ints but you know... javascript.
 */
type DeviceTrapsStatus = Record<string, boolean>;

class DeviceTrapsStatusStore {
  @observable
  fetched = false;

  @observable.ref
  lastFetched: DeviceTrapsStatus = {};

  @observable.ref
  fetchPromise: Promise<DeviceTrapsStatus> | null = null;

  @action
  getDeviceTrapsStatus = () => {
    if (!this.fetchPromise) {
      this.fetchPromise = api
        .get('/api/ui/devices/traps/query')
        .then((results: DeviceTrapsStatus) => {
          runInAction(() => {
            this.fetched = true;
            this.lastFetched = results;
          });
          return results;
        })
        .catch((error: unknown) => {
          runInAction(() => {
            this.fetchPromise = null;
          });
          throw error;
        });
    }
    return this.fetchPromise;
  };
}

export const DeviceTrapsStatus = new DeviceTrapsStatusStore();
